import React from 'react';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useSelector } from 'react-redux';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFooterMenu,
  getNavigationList,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { get } from 'lodash';
import { EFooterMenuType } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';
import FooterMenuCol from './FooterCol';

const FooterMenu = (props) => {
  const _navigationList = useSelector(getNavigationList());
  const { data, isPrimary } = props;
  const arrayData: any = Object.values(data).reduce((pre: any, now: any) => {
    return [...pre, ...(now || [])];
  }, []);
  const occupiedNavis: any = arrayData.reduce((pre: string[], now) => {
    const uuid: string = get(now, 'navigationGroups');
    if (uuid) {
      return [...pre, uuid];
    }
    return pre;
  }, []);
  const navigationList = _navigationList.map((i) => {
    const { uuid } = i;
    const isOccupied = occupiedNavis.includes(uuid);
    return { ...i, isOccupied };
  });

  const occupiedSpecificField = arrayData.reduce(
    (pre: any, now) => {
      const menuItemType = get(now, 'menuItemType');
      if (EFooterMenuType.LocationSelector === menuItemType) {
        return { ...pre, [EFooterMenuType.LocationSelector]: true };
      }
      if (EFooterMenuType.LanguageSelector === menuItemType) {
        return { ...pre, [EFooterMenuType.LanguageSelector]: true };
      }
      if (EFooterMenuType.CurrencySelector === menuItemType) {
        return { ...pre, [EFooterMenuType.CurrencySelector]: true };
      }
      if (EFooterMenuType.SocialMedia === menuItemType) {
        return { ...pre, [EFooterMenuType.SocialMedia]: true };
      }
      return pre;
    },
    {
      [EFooterMenuType.LocationSelector]: false,
      [EFooterMenuType.LanguageSelector]: false,
      [EFooterMenuType.CurrencySelector]: false,
      [EFooterMenuType.SocialMedia]: false,
    },
  );
  //console.log('occupiedSpecificField', occupiedSpecificField);
  return (
    <React.Fragment>
      <FooterMenuCol
        isPrimary={isPrimary}
        data={data['footerMenuColumn1'] || []}
        level={'1'}
        navigationList={navigationList}
        occupiedSpecificField={occupiedSpecificField}
      />
      <FooterMenuCol
        isPrimary={isPrimary}
        data={data['footerMenuColumn2'] || []}
        level={'2'}
        navigationList={navigationList}
        occupiedSpecificField={occupiedSpecificField}
      />
      <FooterMenuCol
        isPrimary={isPrimary}
        data={data['footerMenuColumn3'] || []}
        level={'3'}
        navigationList={navigationList}
        occupiedSpecificField={occupiedSpecificField}
      />
      <FooterMenuCol
        isPrimary={isPrimary}
        data={data['footerMenuColumn4'] || []}
        level={'4'}
        navigationList={navigationList}
        occupiedSpecificField={occupiedSpecificField}
      />
      <FooterMenuCol
        isPrimary={isPrimary}
        data={data['footerMenuColumn5'] || []}
        level={'5'}
        navigationList={navigationList}
        occupiedSpecificField={occupiedSpecificField}
      />
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(FooterMenu, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.footerMenu,
  getContent: getFooterMenu,
  title: getI18nFromGeneral('general.hOCTitle.footerMenu'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  expandOffset: 0,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      // {
      //   onClick: () => {
      //     const dD = generateFooterStyle();
      //     store.dispatch(onFooterStyleChange(dD));
      //   },
      //   key: 'Reset',
      //   body: 'Reset',
      //   isDangerous: true,
      // },
    ],
    hasDots: false,
    hideDotsWhenNotPrimary: true,
  },
});
